import { render } from "./CartDetailItem.vue?vue&type=template&id=dbcd5980"
import script from "./CartDetailItem.vue?vue&type=script&lang=js"
export * from "./CartDetailItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__